<!-- Specific Course -->
<section class="default">

    <!-- Page Title -->
    <div class="text-center">
        <h1>{{course.courseID}}</h1>
    </div>
    <hr class="line">
    <br>

    <!-- Continue Course -->
    <div class="container content-box continue-bar" (click)="continueCourse()">
        <circle-progress [percent]="progress" [radius]="80" [outerStrokeWidth]="14" [innerStrokeWidth]="7" [outerStrokeColor]="outerColor" [innerStrokeColor]="innerColor" [animation]="true" [animationDuration]="300"></circle-progress>
        <!-- Course not started-->
        <h1 *ngIf="course.furthestModuleID === 0 && course.furthestPageID === 0">Begin Course</h1>

        <!-- Course started -->
        <h1 *ngIf="(course.furthestModuleID > 0 || course.furthestPageID > 0) && (course.furthestModuleID < modules.length || (course.postTestRequired ? !course.postTestPassed : false))">Continue Course</h1>

        <!-- Course finished-->
        <h1 *ngIf="course.furthestModuleID >= modules.length && (course.postTestRequired ? course.postTestPassed : true) && user.ageUnder18 === true">Get Certificate</h1>
        <h1 *ngIf="course.furthestModuleID >= modules.length && (course.postTestRequired ? course.postTestPassed : true) && user.ageUnder18 !== true" class="add-property-tab">Add/View Properties you Rent</h1>
    </div>
</section>

<!-- Completed Modules -->
<section>
    <div class="module-title">
        <h1>Modules</h1>
    </div>
    <hr class="line">
    <br>
    <!-- Module Tabs -->
    <div class="container modules text-center">

        <!-- Pre-Evaluation Survey -->
        <div class="content-row" *ngIf="course.preTestRequired">
          <button type="button" class="mat-raised-button survey-tab text-white" [routerLink]="'./pre-evaluation'"
              [ngClass]="[course.preTestPassed ? 'bg-success passed' : 'bg-primary']">
            <h3>Pre-evaluation</h3>
          </button>
        </div>

        <!-- Module -->
        <div class="content-box module-tab" *ngFor="let module of modules; index as i; first as first" [routerLink]="['./m', i + 1]"
            [class.disabled]="(first && course.preTestRequired && !course.preTestPassed) || course.furthestModuleID < i">
          <h3>{{i+1}}. {{module.title}}</h3>
        </div>

        <!-- Post-Evaluation Survey -->
        <div class="content-row" *ngIf="course.postTestRequired">
          <button type="button" class="mat-raised-button survey-tab text-white" [routerLink]="'./post-evaluation'"
              [ngClass]="[course.postTestPassed ? 'bg-success passed' : 'bg-primary']"
              [class.disabled]="course.furthestModuleID < modules.length && !course.postTestPassed">
            <h3>Post-evaluation</h3>
          </button>
        </div>
    </div>
</section>

<!-- Agency -->
<section class="section">

    <!-- Title -->
    <div class="module-title">
        <h1>Agency Info</h1>
    </div>
    <hr class="line">
    <br>

    <!-- Agency Info -->
    <div class="container content-box agency-box">
        <h2>Agency Name: <span class="agency-info">{{ agency.agencyName }}</span></h2>
        <h3>Coordinator Name: <span class="agency-info">{{ agency.coordinatorName}}</span></h3>
        <h4>Email: <span class="agency-info">{{ agency.email }}</span></h4>
        <h4>Phone Number: <span class="agency-info">{{ agency.phone }}</span></h4>
    </div>
</section>

<!-- Certificate Tab -->
<section class="section">

    <!-- Title -->
    <div class="module-title">
        <h1>Certificate</h1>
    </div>

    <hr class="line">
    <br>
    <!-- Get Certificate -->
    <div class="container content-box continue-bar" [class.disabled]="course.furthestModuleID < modules.length || (course.postTestRequired ? !course.postTestPassed : false)" [routerLink]="'./certificate'">

        <!-- Course not complete -->
        <h1 *ngIf="course.furthestModuleID < modules.length || (course.postTestRequired ? !course.postTestPassed : false)">Complete Course to get Certificate</h1>

        <!-- Course complete -->
        <h1 *ngIf="course.furthestModuleID >= modules.length && (course.postTestRequired ? course.postTestPassed : true)">Get Certificate</h1>
    </div>
</section>

<!-- Properties Tab -->
<section class="properties-section" *ngIf="user.ageUnder18 !== true">

  <!-- Title -->
  <div class="module-title">
      <h1>Properties</h1>
  </div>
  <hr class="line">
  <br>

  <!-- Properties -->
  <div class="container content-box continue-bar" [class.disabled]="course.furthestModuleID < modules.length" [routerLink]="'./properties'">


      <!-- Course not complete -->
      <h1 *ngIf="course.furthestModuleID < modules.length">Complete Course to add properties you rent</h1>

      <!-- Course complete -->
      <h1 *ngIf="course.furthestModuleID >= modules.length" class="add-property-tab">Add/View Properties you Rent</h1>
  </div>
</section>
